import { ReactNode } from 'react';

/** 属性定義 */
type Props = {
  children: ReactNode;
  name: string;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'reset';
  onClick?: (e: React.UIEvent<Element, UIEvent>) => void;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtExcuteButton = ({ children, name, className, disabled, type, onClick }: Props) => {
  return (
    <button
      name={name}
      className={`atexecutebutton ${className}`}
      disabled={disabled}
      type={type}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
/** 初期値の設定 */
AtExcuteButton.defaultProps = {
  className: '',
  disabled: false,
  type: 'button',
  onClick: null,
};
export default AtExcuteButton;
